// Base
import Image from 'next/image'

// Components
import { Box, Flex, Text } from 'yard-utilities/components'

// Assets
import FullRefundImage from '@images/v21/photos/full-refund-no-shadow.png'

const FullRefundBanner = () => {
  return (
    <Box
      backgroundColor="white"
      border="grey-4"
      borderRadius={{ sm: [8] }}
      padding={{ sm: [16] }}
    >
      <Flex alignItems="center" columnGap={{ sm: 16 }}>
        <Image
          src={FullRefundImage}
          width={64}
          height={48}
          alt="Full Refund image"
          sizes="150px"
          style={{ minWidth: '64px' }}
        />

        <div>
          <Text variant="title-3" spacing={{ sm: 4 }}>
            Prometemos
          </Text>

          <Text variant="body-3">
            Reserva tu primer viaje y obtén un reembolso completo de tu pago
          </Text>
        </div>
      </Flex>
    </Box>
  )
}

export default FullRefundBanner
